export default {

    _form: null,
    _flashConatiner : null,
    
    init() {
        this._form = document.querySelectorAll('form');

        return;
        if (!this._form) {
        }
        for (const form of this._form) {
            form.addEventListener('beforeSproutFormsSubmit', function (event) {
                let postvalue = false;
                for (const field of form) {
                    if (field.name.includes('fields[customerNr')) {
                        event.preventDefault();
                        let postvalue = JSON.stringify({ "customerNr": field.value });
                        let fd = new FormData(form);
                        fd.append("customerNr", field.value);
                        fd.append("fieldName", field.id.split('-')[1]);
                        let XHR = new XMLHttpRequest();
                        // console.log(document.getElementById('g-recaptcha-response').value);
                    //    grecaptcha.execute();
                        XHR.onreadystatechange = () => {
                            this._flashConatiner = form.parentNode.getElementsByClassName('flash')[0];
                            if (XHR.responseText) {
                                const response = JSON.parse(XHR.responseText);
                                if (response.status === true) {
                                    if (this._flashConatiner) {
                                        this._flashConatiner.style.display = "none"
                                    }
                                    window.location.href = window.location.href + '?success=true';
                                }
                                else {
                                    if (!this._flashConatiner) {
                                        this._flashConatiner = document.createElement('div');
                                        this._flashConatiner.innerHTML = response.message;
                                        this._flashConatiner.className = 'flash flash--notice';
                                        form.parentNode.insertBefore(this._flashConatiner, form )
                                    }
                                    else {
                                        this._flashConatiner.innerHTML = response.message;
                                    }
                                    this._flashConatiner.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                                    event.stopPropagation();
                    
                                }
                            }
                        };
                        XHR.open("POST", "/actions/istad/elwin/verify");
                        XHR.send(fd);
                    }
                }
            }, false);
          
            
        }
    }
}